import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SearchBar, Pagination } from "../../components";
import { closeModal } from "../../store/slices/deleteModalSlice";
import {
  fetchDataDrivingSchools,
  setPage,
} from "../../store/slices/apiDrivingSchoolsSlice";
import { openModal } from "../../store/slices/editModalSlice";
import { openModalDelete } from "../../store/slices/deleteModalDrivingSchoolsSlice";
import AddModalDrivingSchools from "../Modals/AddModalDrivingSchools";
import EditModalDrivingSchools from "../Modals/EditModal/EditModalDrivingSchools";
import DeleteModalDrivingSchools from "../Modals/DeleteModal/DeleteModalDrivingSchools";

const TableDriving = () => {
  const dispatch = useDispatch();
  const dataDrivingSchools = useSelector(
    (state) => state.apiDrivingSchools.data
  );
  const currentPage = useSelector(
    (state) => state.apiDrivingSchools.currentPage
  );
  const totalCount = useSelector((state) => state.apiDrivingSchools.totalCount);
  const editModalState = useSelector((state) => state.editModalDrivingSchools);

  const [searchInput, setSearchInput] = useState("");
  const prevSearchRef = useRef("");


  useEffect(() => {
    const pageToUse =
      prevSearchRef.current !== searchInput ? 1 : currentPage;
  
    if (prevSearchRef.current !== searchInput) {
      dispatch(setPage(1)); // make sure this updates the correct Redux slice
      prevSearchRef.current = searchInput;
    }
  
    dispatch(
      fetchDataDrivingSchools({ page: pageToUse, searchQuery: searchInput })
    );
  }, [dispatch, currentPage, searchInput]);
  

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(
      fetchDataDrivingSchools({ page: currentPage, searchQuery: searchInput })
    );
  };

  const handleEditSuccess = () => {
    dispatch(
      fetchDataDrivingSchools({ page: currentPage, searchQuery: searchInput })
    );
  };

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleEditItem = (id) => {
    dispatch(openModal(id));
  };

  const handleDeleteItem = (id) => {
    dispatch(openModalDelete(id));
  };

  const getYesNoTextFromBoolean = (value) => (value ? "Po" : "Jo");
  const getStatusTextFromBoolean = (value) => (value ? "Aktiv" : "Pasiv");

  return (
    <div className="p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 pb-4 bg-white dark:bg-gray-900">
        <SearchBar
          searchInput={searchInput}
          handleSearchInputChange={handleSearchInputChange}
          handleSearchSubmit={handleSearchSubmit}
        />
        <AddModalDrivingSchools
          title="Shto nje autoshkolle"
          drivingSchoolName="Shto një autoshkollë"
          cityName="Qyteti"
          schoolStatus="Statusi"
          schoolStatus2="Pare"
          schoolNumber="Numri i telefonit"
          emailSchoolName="Email"
          passwordSchoolName="Fjalëkalimi"
          submitButtonText="Shto autoshkollën"
          onCancel={handleCloseModal}
          onSuccess={handleEditSuccess}
        />
      </div>

      <div className="overflow-x-auto shadow-md sm:rounded-lg">
      <div className="hidden sm:block">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400 table-fixed">
            <thead className="text-sm text-[#718EBF] bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th className="px-3 py-3 whitespace-normal">
                  Emri i <br /> autoshkollës
                </th>
                <th className="px-3 py-3 whitespace-normal">Email</th>
                <th className="px-3 py-3 whitespace-normal">Qyteti</th>
                <th className="px-3 py-3 whitespace-normal">
                  Numri i <br /> telefonit
                </th>
                <th className="px-3 py-3 whitespace-normal">
                  Me <br /> kartele fizike
                </th>
                <th className="px-3 py-3 whitespace-normal">Me cash</th>
                <th className="px-3 py-3 whitespace-normal">
                  Data e <br /> krijimit
                </th>
                <th className="px-3 py-3 whitespace-normal">Statusi</th>
                <th className="px-3 py-3 whitespace-normal">Aksionet</th>
              </tr>
            </thead>
            <tbody>
              {dataDrivingSchools?.data?.map((item) => (
                <tr
                  key={item.id}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <td
                    className="px-4 py-4 font-medium text-gray-900 truncate max-w-[160px] dark:text-white"
                    title={item.name}
                  >
                    {item.name}
                  </td>
                  <td className="px-4 py-4 truncate max-w-[200px]">
                    {item.userEmail}
                  </td>
                  <td className="px-4 py-4 truncate max-w-[120px]">
                    {item.city}
                  </td>
                  <td className="px-4 py-4 truncate max-w-[140px]">
                    {item.phoneNumber}
                  </td>
                  <td className="px-4 py-4 truncate max-w-[120px]">
                    {getYesNoTextFromBoolean(item.card)}
                  </td>
                  <td className="px-4 py-4 truncate max-w-[120px]">
                    {getYesNoTextFromBoolean(item.cash)}
                  </td>
                  <td className="px-4 py-4 truncate max-w-[180px]">
                    {new Date(item.created_at).toLocaleString("en-US", {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                      hour12: false,
                    })}
                  </td>
                  <td className="px-4 py-4 truncate max-w-[100px]">
                    <div
                      className={`px-2 py-1 rounded-full w-fit text-white ${
                        item.status === 1 ? "bg-green-500" : "bg-red-500"
                      }`}
                    >
                      {getStatusTextFromBoolean(item.status)}
                    </div>
                  </td>
                  <td className="">
                    <div className="flex items-center gap-3">
                      <button
                        className="text-green-600 hover:text-green-800"
                        onClick={() => handleEditItem(item.id)}
                      >
                        <EditModalDrivingSchools
                          title="Edito nje autoshkollë"
                          id={item.id}
                          drivingSchoolName="Edito një autoshkollë"
                          cityName="Qyteti"
                          schoolStatus="Statusi"
                          schoolCash="Me para ne dore"
                          submitButtonText="Edito"
                          isOpen={editModalState[item.id] === true}
                          onSuccess={handleEditSuccess}
                        />
                      </button>

                      <button
                        className="text-red-600 hover:text-red-800"
                        onClick={() => handleDeleteItem(item.id)}
                      >
                        <DeleteModalDrivingSchools id={item.id} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="block sm:hidden space-y-4">
          {dataDrivingSchools?.data?.map((item) => (
            <div
              key={item.id}
              className="bg-white shadow rounded-lg p-4 text-sm space-y-2"
            >
              <p>
                <strong>Emri:</strong> {item.name}
              </p>
              <p>
                <strong>Email:</strong> {item.userEmail}
              </p>
              <p>
                <strong>Qyteti:</strong> {item.city}
              </p>
              <p>
                <strong>Numri:</strong> {item.phoneNumber}
              </p>
              <p>
                <strong>Me kartelë:</strong>{" "}
                {getYesNoTextFromBoolean(item.card)}
              </p>
              <p>
                <strong>Me cash:</strong> {getYesNoTextFromBoolean(item.cash)}
              </p>
              <p>
                <strong>Data:</strong>{" "}
                {new Date(item.created_at).toLocaleString("en-US", {
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                  hour12: false,
                })}
              </p>
              <p>
                <strong>Statusi:</strong>{" "}
                {getStatusTextFromBoolean(item.status)}
              </p>
              <div className="flex items-center gap-3">
                <EditModalDrivingSchools
                  title="Edito nje autoshkollë"
                  id={item.id}
                  drivingSchoolName="Edito një autoshkollë"
                  cityName="Qyteti"
                  schoolStatus="Statusi"
                  schoolCash="Me para ne dore"
                  submitButtonText="Edito"
                  isOpen={editModalState[item.id] === true}
                  onSuccess={handleEditSuccess}
                />
                <DeleteModalDrivingSchools id={item.id} />
              </div>
            </div>
          ))}
        </div>

        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default TableDriving;
